import React from "react";
import Page from "../../../layout/web/Page"
import Connector from "../../../redux/connector";
import Title from "../../../components/Common/Title";
import LoadingProcessing from "../../../components/Common/page/Common/LoadingProcessing";
import {Modal, Button, Select, Form} from 'antd';
import AddPagePdfHtml2 from "../../../components/web/Document/AddPagePdfHtml2";
import AddPagePdfHtml from "../../../components/web/Document/AddPagePdfHtml";
import jsPDF from "jspdf";
import ReactHtmlParser from "react-html-parser";
import {StyleSheet} from "@react-pdf/renderer";
import {fetchDataEntity} from "../../../api/entity-data";
import {PostToPbx} from "../../../api/http-post";
import {ConvertBase64IntoString, SortData} from "../../../api/fn";
const {Option} = Select;

class DocGenTemplatePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Companies:[],
            Infos:[],
            Templates:[],
            pages: [],
            show: false,
            genShow:false,
            selectedCompany:"",
            selectedInfo:"",
            selectedRow:null,
        }
    }
    componentDidMount = async () => {
        await this.loadInitialData();
    }
    loadInitialData = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await fetchDataEntity("Infos", "pdf/entity", "info", this,false);
        await fetchDataEntity("Templates", "pdf/entity", "template", this,false)
        //await fetchDataEntity("Data", "manager/entity", "extensions", this, false);
    }

    handleOk = () => {
        this.setState({
            show: false
        })
    }

    showModal = () => {
        this.setState({
            show: true
        })
    }
    showModal2 = () => {
        this.setState({
            show2: true
        })
    }
    onCloseModal=()=>{
        this.setState({
            show: false,
            selectedRow:null,
        })
    }
    onCloseModal2=()=>{
        this.setState({
            show2: false,
            selectedRow:null,
        })
    }

    renderAddPageForm = () => {
        if (!this.state.show) {
            return null
        }

        return (
            <div>
                <Modal
                    title="Add Page"
                    visible={this.state.show}
                    onOk={this.handleOk}
                    style={{minWidth:580,minHeight:920}}
                    footer={null}
                >
                    <AddPagePdfHtml
                        _this={this}
                        keyShow={"show"}
                    />
                </Modal>
            </div>
        )
    }
    renderAddPageForm2 = () => {
        if (!this.state.show2) {
            return null
        }

        return (
            <div>
                <Modal
                    title="Add Page"
                    visible={this.state.show2}
                    onOk={this.handleOk}
                    style={{minWidth:580,minHeight:920}}
                    footer={null}
                >
                    <AddPagePdfHtml2
                        _this={this}
                        keyShow={"show2"}
                    />
                </Modal>
            </div>
        )
    }

    genPDF=()=>{
        let doc = new jsPDF('p', 'pt', 'letter');
        let margins = {
            top: 50,
            left: 60,
            width: 545
        };
        for(let i in this.state.pages){
            let pageData = this.state.pages[i];
            doc.fromHTML(window.document.getElementById("congo-"+i),
                margins.left // x coord
                , margins.top, // y coord,{});
                {
                    'width': margins.width // max width of content on PDF

                },)
            doc.addPage()
        }
        //doc.save("Test.pdf")

        let iframe = document.createElement('iframe');
        iframe.setAttribute('style','position:absolute;right:0; top:0; bottom:0; height:100%; width:650px; padding:20px;');
        document.body.appendChild(iframe);
        iframe.src = doc.output('datauristring');
    }
    handleChange = (value,key) => {
        console.log("handleChange :> ",value)
        this.setState({
            [key]: value,
        })
    }
    handleChangeCompany = (value,key) => {
        console.log("handleChange :> ",value)
        this.setState({
            [key]: value,
            selectedInfo:""
        })
    }
    renderInfosSelection=()=>{
        let ls=[];
        for(let i in this.state.Infos){
            const row = this.state.Infos[i];
            if(row.Org!==this.state.selectedCompany){
                continue
            }
            ls.push(row)
        }
        return(
            <Form.Item
                label={"Select Category"}
                name={"selectedInfo"}
                rules={[{required: true, message: "Please select your category!"}]}
            >
                <Select
                    style={{ width: "100%" }}
                    onChange={(value)=>this.handleChange(value,"selectedInfo")}
                    value={this.state.selectedInfo}
                >
                    {ls.map((record, index) => {
                        return (
                            <Option
                                key={record.Name}
                                value={record.Name}
                            >
                                {record.Name}
                            </Option>
                        )
                    })}
                </Select>
            </Form.Item>

        )
    }
    renderCompaniesSelection=()=>{
        let ls=this.state.Companies;
        return(
            <Form.Item
                label={"Select Company"}
                name={"selectedCompany"}
                rules={[{required: true, message: "Please select your company!"}]}
            >
                <Select
                    style={{ width: "100%" }}
                    onChange={(value)=>this.handleChangeCompany(value,"selectedCompany")}
                    value={this.state.selectedCompany}
                >
                    {ls.map((record, index) => {
                        return (
                            <Option
                                key={record.CustomerNumber}
                                value={record.CustomerNumber}
                            >
                                {record.Name}
                            </Option>
                        )
                    })}
                </Select>
            </Form.Item>

        )

    }
    addPage=async (body,position)=>{
        let _this=this;
        let hub={
            Org:this.state.selectedCompany,
            DocRef:this.state.selectedInfo,
            Position:parseInt(position),
            Body:body
        }
        let endpoint = "/pdf/entity/insert/template";
        console.log("AddPage request > ",hub);
        await PostToPbx(hub, endpoint, async (data) => {
            if (data === null) {
                alert("Sorry connection error try late");
                return
            }
            alert("New page added")
            _this.setState({
                isLoading: false,
                pages: []
            })
            await fetchDataEntity("Templates", "pdf/entity", "template", _this)
        });
    }
    onDeletePage=async (row)=>{
        let _this = this;
        if(!window.confirm("Are you sure you want to delete this document? ",row.Position)){
            return
        }
        let hub={...row}
        let endpoint = "/pdf/entity/remove/template";
        console.log("onDeletePage request > ",row);
        await PostToPbx(hub, endpoint, async (data) => {
            if (data === null) {
                alert("Sorry connection error try late");
                return
            }
            _this.setState({
                isLoading: false,
                pages: []
            })
            await fetchDataEntity("Templates", "pdf/entity", "template", _this)
            alert("Page deleted!")
        });
    }
    onEditPage=(row)=>{
        this.setState({
            selectedRow:row,
        });
        this.showModal();
    }
    renderBody=()=>{
        let pages=[];
        for(let i in this.state.Templates){
            let row = this.state.Templates[i];
            if(row.Org===this.state.selectedCompany&&row.DocRef===this.state.selectedInfo){
                pages.push(row)
            }
        }

        pages = SortData("Position",pages);

        return pages.map((row,index)=>{
            let item = ConvertBase64IntoString(row.Body);//TODO convert it to string from base64
            return(
                <div style={{minWidth:"100%"}}>
                    <Button type="secondary" onClick={()=>this.onDeletePage(row)}
                            style={{
                                float:"left",backgroundColor:"red",marginRight:10,
                                color:"white"
                            }}>
                        DELETE page({row.Position})
                    </Button>
                    <Button type="primary" onClick={()=>this.onEditPage(row)} style={{float:"left"}}>
                        EDIT page({row.Position})
                    </Button>
                <div
                    id={"congo-"+index}
                    style={{
                        paddingTop: 50,
                        paddingLeft: 60,
                        paddingRight: 60,
                        paddingBottom:50,
                        width: "29.7cm",
                        /*height: "21cm",*/
                        maxWidth:"29.7cm",
                        minWidth:"29.7cm",
                        minHeight:"21cm",
                        /*maxHeight:"21cm",*/
                        backgroundColor:"white",
                        margin:20
                    }}

                >
                    {ReactHtmlParser(additionalStyle+item)}
                </div>
                </div>
            )
        })
    }
    render() {
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    overflow: "auto"
                }}>
                    <Title style={styles.title}>Document Template Builder</Title>
                    <div style={{minWidth: "100%",padding:10}}>
                        {this.renderCompaniesSelection()}
                    </div>
                    <div style={{minWidth: "100%",padding:10}}>
                        {this.renderInfosSelection()}
                    </div>
                    <div style={{minWidth: "100%",padding:10}}>
                        <Button type="default" onClick={this.showModal} style={{float:"right",margin:10}}>
                            Add Page
                        </Button>
                        <Button type="default" onClick={this.showModal2} style={{float:"right",margin:10}}>
                            Add Page 2
                        </Button>

                    </div>
                    <div className={"body"} style={{marginTop:50,maxWidth:5560}}>
                        {this.renderBody()}
                    </div>
                    {this.renderAddPageForm()}
                    {this.renderAddPageForm2()}
                    {/*<div className={"body"} style={{marginTop:50}}>
                        {this.state.pages.map((item,index)=>{
                            return(
                                <div
                                    id={"congo-"+index}
                                    className="html-2-pdfwrapper"
                                    style={{
                                        paddingTop: 50,
                                        paddingLeft: 60,
                                        paddingRight: 60,
                                        width: "29.7cm",
                                        height: "21cm",
                                        maxWidth:"29.7cm",
                                        minWidth:"29.7cm",
                                        minHeight:"21cm",
                                        maxHeight:"21cm",
                                    }}

                                >
                                    {ReactHtmlParser(item)}
                                </div>
                            )
                        })}
                    </div>*/}


                </div>
                <LoadingProcessing open={this.state.isLoading}/>
            </Page>
        )
    }
}


export default Connector(DocGenTemplatePage);

const styles = StyleSheet.create({
    page: {
        backgroundColor: "#ffffff"
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    movieContainer: {
        backgroundColor: "#f6f6f5",
        display: "flex",
        flexDirection: "row",
        padding: 5
    },
    movieDetails: {
        display: "flex",
        marginLeft: 5
    },
    movieTitle: {
        fontSize: 15,
        marginBottom: 10
    },
    movieOverview: {
        fontSize: 10
    },

    image: {
        height: 200,
        width: 150
    },
    subtitle: {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        width: 150,
        alignItems: "center",
        marginBottom: 12
    },
    vote: {
        display: "flex",
        flexDirection: "row"
    },
    rating: {
        height: 10,
        width: 10
    },
    vote_text: {
        fontSize: 10
    },
    vote_pop: {
        fontSize: 10,
        padding: 2,
        backgroundColor: "#61C74F",
        color: "#fff"
    },
    vote_pop_text: {
        fontSize: 10,
        marginLeft: 4
    },
    overviewContainer: {
        minHeight: 110
    },
    detailsFooter: {
        display: "flex",
        flexDirection: "row"
    },
    lang: {
        fontSize: 8,
        fontWeight: 700
    },
    vote_average: {
        fontSize: 8,
        marginLeft: 4,
        fontWeight: "bold"
    },
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
});


const additionalStyle=
    `<style type="text/css">
.clearfix::after{clear:both;display:block;content:"";height:0}.hide-by-clipping{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}img.fr-rounded,.fr-img-caption.fr-rounded img{border-radius:10px;-moz-border-radius:10px;-webkit-border-radius:10px;-moz-background-clip:padding;-webkit-background-clip:padding-box;background-clip:padding-box}img.fr-bordered,.fr-img-caption.fr-bordered img{border:solid 5px #CCC}img.fr-bordered{box-sizing:content-box}.fr-img-caption.fr-bordered img{box-sizing:border-box}.fr-view{word-wrap:break-word}.fr-view span[style~="color:"] a{color:inherit}.fr-view strong{font-weight:700}.fr-view table{border:none;border-collapse:collapse;empty-cells:show;max-width:100%}.fr-view table td{min-width:5px}.fr-view table.fr-dashed-borders td,.fr-view table.fr-dashed-borders th{border-style:dashed}.fr-view table.fr-alternate-rows tbody tr:nth-child(2n){background:whitesmoke}.fr-view table td,.fr-view table th{border:1px solid #DDD}.fr-view table td:empty,.fr-view table th:empty{height:20px}.fr-view table td.fr-highlighted,.fr-view table th.fr-highlighted{border:1px double red}.fr-view table td.fr-thick,.fr-view table th.fr-thick{border-width:2px}.fr-view table th{background:#ececec}.fr-view hr{clear:both;user-select:none;-o-user-select:none;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-ms-user-select:none;page-break-after:always;break-after:always;page-break-after:always}.fr-view .fr-file{position:relative}.fr-view .fr-file::after{position:relative;content:"\\1F4CE";font-weight:normal}.fr-view pre{white-space:pre-wrap;word-wrap:break-word;overflow:visible}.fr-view[dir="rtl"] blockquote{border-left:none;border-right:solid 2px #5E35B1;margin-right:0;padding-right:5px;padding-left:0}.fr-view[dir="rtl"] blockquote blockquote{border-color:#00BCD4}.fr-view[dir="rtl"] blockquote blockquote blockquote{border-color:#43A047}.fr-view blockquote{border-left:solid 2px #5E35B1;margin-left:0;padding-left:5px;color:#5E35B1}.fr-view blockquote blockquote{border-color:#00BCD4;color:#00BCD4}.fr-view blockquote blockquote blockquote{border-color:#43A047;color:#43A047}.fr-view span.fr-emoticon{font-weight:normal;font-family:"Apple Color Emoji","Segoe UI Emoji","NotoColorEmoji","Segoe UI Symbol","Android Emoji","EmojiSymbols";display:inline;line-height:0}.fr-view span.fr-emoticon.fr-emoticon-img{background-repeat:no-repeat !important;font-size:inherit;height:1em;width:1em;min-height:20px;min-width:20px;display:inline-block;margin:-.1em .1em .1em;line-height:1;vertical-align:middle}.fr-view .fr-text-gray{color:#AAA !important}.fr-view .fr-text-bordered{border-top:solid 1px #222;border-bottom:solid 1px #222;padding:10px 0}.fr-view .fr-text-spaced{letter-spacing:1px}.fr-view .fr-text-uppercase{text-transform:uppercase}.fr-view .fr-class-highlighted{background-color:#ffff00}.fr-view .fr-class-code{border-color:#cccccc;border-radius:2px;-moz-border-radius:2px;-webkit-border-radius:2px;-moz-background-clip:padding;-webkit-background-clip:padding-box;background-clip:padding-box;background:#f5f5f5;padding:10px;font-family:"Courier New", Courier, monospace}.fr-view .fr-class-transparency{opacity:0.5}.fr-view img{position:relative;max-width:100%}.fr-view img.fr-dib{margin:5px auto;display:block;float:none;vertical-align:top}.fr-view img.fr-dib.fr-fil{margin-left:0;text-align:left}.fr-view img.fr-dib.fr-fir{margin-right:0;text-align:right}.fr-view img.fr-dii{display:inline-block;float:none;vertical-align:bottom;margin-left:5px;margin-right:5px;max-width:calc(100% - (2 * 5px))}.fr-view img.fr-dii.fr-fil{float:left;margin:5px 5px 5px 0;max-width:calc(100% - 5px)}.fr-view img.fr-dii.fr-fir{float:right;margin:5px 0 5px 5px;max-width:calc(100% - 5px)}.fr-view span.fr-img-caption{position:relative;max-width:100%}.fr-view span.fr-img-caption.fr-dib{margin:5px auto;display:block;float:none;vertical-align:top}.fr-view span.fr-img-caption.fr-dib.fr-fil{margin-left:0;text-align:left}.fr-view span.fr-img-caption.fr-dib.fr-fir{margin-right:0;text-align:right}.fr-view span.fr-img-caption.fr-dii{display:inline-block;float:none;vertical-align:bottom;margin-left:5px;margin-right:5px;max-width:calc(100% - (2 * 5px))}.fr-view span.fr-img-caption.fr-dii.fr-fil{float:left;margin:5px 5px 5px 0;max-width:calc(100% - 5px)}.fr-view span.fr-img-caption.fr-dii.fr-fir{float:right;margin:5px 0 5px 5px;max-width:calc(100% - 5px)}.fr-view .fr-video{text-align:center;position:relative}.fr-view .fr-video.fr-rv{padding-bottom:56.25%;padding-top:30px;height:0;overflow:hidden}.fr-view .fr-video.fr-rv>iframe,.fr-view .fr-video.fr-rv object,.fr-view .fr-video.fr-rv embed{position:absolute !important;top:0;left:0;width:100%;height:100%}.fr-view .fr-video>*{box-sizing:content-box;max-width:100%;border:none}.fr-view .fr-video.fr-dvb{display:block;clear:both}.fr-view .fr-video.fr-dvb.fr-fvl{text-align:left}.fr-view .fr-video.fr-dvb.fr-fvr{text-align:right}.fr-view .fr-video.fr-dvi{display:inline-block}.fr-view .fr-video.fr-dvi.fr-fvl{float:left}.fr-view .fr-video.fr-dvi.fr-fvr{float:right}.fr-view a.fr-strong{font-weight:700}.fr-view a.fr-green{color:green}.fr-view .fr-img-caption{text-align:center}.fr-view .fr-img-caption .fr-img-wrap{padding:0;margin:auto;text-align:center;width:100%}.fr-view .fr-img-caption .fr-img-wrap img{display:block;margin:auto;width:100%}.fr-view .fr-img-caption .fr-img-wrap>span{margin:auto;display:block;padding:5px 5px 10px;font-size:14px;font-weight:initial;box-sizing:border-box;-webkit-opacity:0.9;-moz-opacity:0.9;opacity:0.9;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";width:100%;text-align:center}.fr-view button.fr-rounded,.fr-view input.fr-rounded,.fr-view textarea.fr-rounded{border-radius:10px;-moz-border-radius:10px;-webkit-border-radius:10px;-moz-background-clip:padding;-webkit-background-clip:padding-box;background-clip:padding-box}.fr-view button.fr-large,.fr-view input.fr-large,.fr-view textarea.fr-large{font-size:24px}a.fr-view.fr-strong{font-weight:700}a.fr-view.fr-green{color:green}img.fr-view{position:relative;max-width:100%}img.fr-view.fr-dib{margin:5px auto;display:block;float:none;vertical-align:top}img.fr-view.fr-dib.fr-fil{margin-left:0;text-align:left}img.fr-view.fr-dib.fr-fir{margin-right:0;text-align:right}img.fr-view.fr-dii{display:inline-block;float:none;vertical-align:bottom;margin-left:5px;margin-right:5px;max-width:calc(100% - (2 * 5px))}img.fr-view.fr-dii.fr-fil{float:left;margin:5px 5px 5px 0;max-width:calc(100% - 5px)}img.fr-view.fr-dii.fr-fir{float:right;margin:5px 0 5px 5px;max-width:calc(100% - 5px)}span.fr-img-caption.fr-view{position:relative;max-width:100%}span.fr-img-caption.fr-view.fr-dib{margin:5px auto;display:block;float:none;vertical-align:top}span.fr-img-caption.fr-view.fr-dib.fr-fil{margin-left:0;text-align:left}span.fr-img-caption.fr-view.fr-dib.fr-fir{margin-right:0;text-align:right}span.fr-img-caption.fr-view.fr-dii{display:inline-block;float:none;vertical-align:bottom;margin-left:5px;margin-right:5px;max-width:calc(100% - (2 * 5px))}span.fr-img-caption.fr-view.fr-dii.fr-fil{float:left;margin:5px 5px 5px 0;max-width:calc(100% - 5px)}span.fr-img-caption.fr-view.fr-dii.fr-fir{float:right;margin:5px 0 5px 5px;max-width:calc(100% - 5px)}
</style>`;
